import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MobileMenu.vue?vue&type=style&index=0&id=a5e45b26&lang=scss"

const __exports__ = script;

export default __exports__